import Button from 'components/Button/Button';
import Icon from 'components/Icon/Icon';
import Text from 'components/Text/Text';
import './InfoTooltip.scss';
import useOnClickOutside from 'hooks/useOnClickOutside';

interface IProps {
  text: string;
  onClose: () => void;
}

const InfoTooltip = ({text, onClose}: IProps) => {
  const renderText = () => {
    const cutLength = 210;

    if (text.length <= cutLength) return text;

    return `${text.substring(0, cutLength)}...`;
  };

  const {containerRef} = useOnClickOutside<HTMLDivElement>(() => {
    onClose();
  });

  return (
    <div ref={containerRef} className="info-tooltip" data-testid="info-tooltip">
      <div className="info-tooltip__close">
        <Button variant="empty" onClick={onClose}>
          <Icon icon="close" />
        </Button>
      </div>
      <Text tag="p" data-testid="info-tooltip-text">
        {renderText()}
      </Text>
    </div>
  );
};

export default InfoTooltip;
